export default __webpack_public_path__ + "static/media/Country.f99cd10e.svg";